import { connect } from 'react-redux';
import BulkDataFeeds from './components/BulkDataFeeds';
import { loadMySubscriptionPlan } from '../../redux/actions/user';
import {
  loadBulkDataFeeds,
  downloadBulkDataFeed,
  clearBulkDataFeeds,
} from '../../redux/actions/bulkData';

const mapStateToProps = (state) => {
  return {
    mySubscriptionPlan: state.user.mySubscriptionPlan,
    mySubscriptionPlanStatus: state.user.mySubscriptionPlanStatus,
    bulkDataFeeds: state.bulkdata.bulkDataFeeds,
    bulkDataFeedsStatus: state.bulkdata.bulkDataFeedsStatus,
    bulkDataDownloadStatus: state.bulkdata.bulkDataDownloadStatus,
    bulkDataDownloadLink: state.bulkdata.bulkDataDownloadLink,
  };
};

const mapDispatchToProps = {
  loadMySubscriptionPlan,
  loadBulkDataFeeds,
  downloadBulkDataFeed,
  clearBulkDataFeeds,
};

export default connect(mapStateToProps, mapDispatchToProps)(BulkDataFeeds);
